import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_reassurance_warranty_title',
    defaultMessage: '1-year warranty',
  },
  free: {
    id: 'product_jp_reassurance_warranty_price',
    defaultMessage: '\\ Free! /',
  },
  item1title: {
    id: 'product_jp_reassurance_warranty_item1_title',
    defaultMessage: 'Free repairs and exchanges',
  },
  item1description: {
    id: 'product_jp_reassurance_warranty_item1_description',
    defaultMessage:
      'If your product develops a defect within one year of purchase, Back Market will repair or replace it for you',
  },
  item2title: {
    id: 'product_jp_reassurance_warranty_item2_title',
    defaultMessage: 'All products covered',
  },
  item2description: {
    id: 'product_jp_reassurance_warranty_item2_description',
    defaultMessage: 'Applies to all products sold on Back Market',
  },
  item3title: {
    id: 'product_jp_reassurance_warranty_item3_title',
    defaultMessage: 'No charge for return shipping',
  },
  item3description: {
    id: 'product_jp_reassurance_warranty_item3_description',
    defaultMessage:
      'We cover the return shipping costs when sending items back to the seller. Returns are quick and easy',
  },
} as Record<string, I18nDefinition>
